// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/toastify/successimg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/toastify/errorimg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/toastify/warnningIcon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../images/toastify/bell.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../images/toastify/info.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Toastify__toast-container {
    z-index: 99999;
    /* -webkit-transform: translate3d(0, 0, 9999px); */
    position: fixed;
    padding: 4px;
    width: 307px;
    box-sizing: border-box;
    color: #fff; 
    word-break: break-all;
}
.Toastify__toast-container--top-left {
  top: 45%;
  right: 0;
  left: 0;
  margin: 0px auto;
}
.Toastify__toast-container--top-center {
  top: 8px;
  right: 0;
  left: 0;
  margin: 0px auto;
}
.Toastify__toast-container--top-right {
  top: 7em;
  right: 1em; 
}
.Toastify__toast-container--bottom-left {
  bottom: 1em;
  left: 1em; 
}
.Toastify__toast-container--bottom-center {
  bottom: 1em;
  left: 50%;
  margin-left: -160px; 
}
.Toastify__toast-container--bottom-right {
  bottom: 1em;
  right: 1em; 
}
  
@media only screen and (max-width: 480px) {
  .Toastify__toast-container {
    width: 95vw;
    padding: 0;
    left: 6px;
    right: 6px;
    margin: 0px auto; 
  }
  .Toastify__toast-container--top-left, .Toastify__toast-container--top-center, .Toastify__toast-container--top-right {
    top: 0; 
  }
  .Toastify__toast-container--bottom-left, .Toastify__toast-container--bottom-center, .Toastify__toast-container--bottom-right {
    bottom: inherit !important; 
    top:10px;
  }
  .Toastify__toast-container--rtl {
    right: 0;
    left: initial; 
  } 
  .titleanddescriptionbox{
      width: 80% !important;
  }
  .message_dec p{
    font-size: 13px !important;
  }
  .titleanddescriptionbox .alert_box {
    padding-top: 6px;
  }
}
  
.Toastify__toast {
	position: relative;
	min-height: 64px;
	box-sizing: border-box;
	margin-bottom: 1rem;
	padding: 8px;
	border-radius: 1px;
	box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05);
	display: -ms-flexbox;
	display: flex;
	-ms-flex-pack: justify;
	justify-content: space-between;
	max-height: 800px;
	overflow: hidden;
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
	cursor: pointer;
	direction: ltr; 
}
.Toastify__toast--rtl {
	direction: rtl; 
}
.Toastify__toast--default {
	background: #fff;
	color: #aaa; 
}
.Toastify__toast--info {
	background: #3498db; 
}
.alert_box{
	padding: 10px 0px 0px 0px;
}
.alert_img{
	width: 50px;
	float: left;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
	background-repeat: no-repeat;
	background-position: 8px center;
	background-color: #fff !important;
  background-size: 50px;
  height: 50px;
  position: relative;
  top: -14px;
  border-radius: 50%;
}
.alert_img_error{
	width: 50px;
	float: left;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
	background-repeat: no-repeat;
	background-color: #fff !important;
  background-size: 50px;
  height: 50px;
  position: relative;
  border-radius: 50%;
}
.alert_img_warning{
	width: 50px;
	float: left;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) !important;
	background-repeat: no-repeat;
	background-color: #fff !important;
  background-size: 50px;
  height: 50px;
  position: relative;
  border-radius: 50%;
}
.alert_box_reminder .alert_box{
  display: flex;
  width: 100%;
  justify-content: flex-start;
  align-items: center;
  padding: 0px !important;
}
.alert_img_reminder{
	width: 45px;
	float: left;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) !important;
	background-repeat: no-repeat;
	background-color: #fff !important;
	background-size: 50px;
  height: 45px;
  position: relative;
  border-radius: 50%;
  background-size: 60%;
  background-position: center center;
  box-shadow: 0px 0px 5px 2px #eee;
}
.infoToastMsg{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.alert_img_info{
  width: 50px;
	float: left;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) !important;
	background-repeat: no-repeat;
	background-color: #fff !important;
  background-size: 50px;
  height: 50px;
  position: relative;
  border-radius: 50%;
}
.infoToastMsg .iconbox{
  width: 50px;
	float: left;
}
.infoToastMsg .alert_img_info img{
	width: 50px;
	height: 50px;
	border-radius: 50%;
	border: 1px solid #DFE0EB;
	padding: 2px 2px;
}
.message_dec{
	display: inline-block;
	width: 80%;
	font-size: 12px;
	color: #8095AB;
  font-family: Poppins-Medium;
  padding: 0px 0px 0px 0.8vw;
}
.message_descriptipn{
  display: inline-block;
	width: 80%;
	font-size: 12px;
	color: #fff !important;
}
.Toastify__toast--success {
  padding: 0.8vw 0.7vw 1vw 0.6vw;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  border-radius: 1vw;
  margin: 0;
	opacity: 1;
	background: #fff;
}
.Toastify__toast--info{
	padding: 15px 15px 15px 50px;
	border-radius: 3px;
	box-shadow: 0 0 12px #999;
	opacity: 0.8;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) !important;
	background-repeat: no-repeat !important;
	background-position: 15px center !important;
	background-color: #2F96B4 !important;
}
.Toastify__toast--warning{
  padding: 0.8vw 0.7vw 1vw 0.6vw;
	border-radius: 1vw;
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
	opacity: 1;
	/*background-image: url("../images/toastify/warning.png") !important;
	background-repeat: no-repeat !important;
	background-position: 15px center !important;*/
	background-color: #fff !important;
}
.Toastify__toast--error{
  padding: 0.8vw 0.7vw 1vw 0.6vw;
	border-radius: 1vw;
	box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
	opacity: 1;
	/*background-image: url("../images/toastify/error.png") !important;
	background-repeat: no-repeat !important;
	background-position: 15px center !important;*/
	background-color: #fff !important;
}
.Toastify__toast--success:hover{
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
	opacity: 1;
}
.Toastify__toast--info:hover{
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
	opacity: 1;
}
.Toastify__toast--warning:hover{
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
	opacity: 1;
}
.Toastify__toast--error:hover{
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
	opacity: 1;
}
.Toastify__toast-body h1{
	margin: 0px 0px 0px 0px;
	font-size: 16px;
	font-weight: 700;
	color: #334D6E;
  padding: 0.5vw 0vw 0vw 3.5vw;
  font-family: Poppins-Medium;
}
.Toastify__toast-body{
	text-align:left;
	color: #555;
}
.Toastify__toast--success:hover{
	opacity: 1;
}
.Toastify__toast--warning {
  background: #f1c40f; 
}
.Toastify__toast--error {
  background: #e74c3c; 
}
.Toastify__toast-body {
  margin: auto 0;
  -ms-flex: 1;
  flex: 1; 
}
.Toastify__toast-body .info_title_text {
    font-size: 15px;
	  color: #000;
}
.warning_message_box h1{
	color: #fff;
	font-size: 16px;
}
.warning_message_box{
	color: #fff;
	font-size: 15px;
}
.error_title{
  color: #fff !important;
	font-size: 15px;
}
.warning_title{
  color: #fff !important;
	font-size: 15px;
}
.error_title_dec{
  font-size: 14px;
}
@media only screen and (max-width: 480px) {
	.Toastify__toast {
	  margin-bottom: 0; } 
}

.Toastify__close-button {
	color: #555;
	font-weight: bold;
	background: transparent;
	outline: none;
	border: none;
	padding: 0;
	cursor: pointer;
	opacity: 1;
	transition: 0.3s ease;
	-ms-flex-item-align: start;
	align-self: flex-start; 
	position: relative;
	top: -6px;
	right: -0px;
	font-weight: 900;
	font-size: 16px;
	text-shadow: 0 1px 0 #fff;
  display: none;
}
.Toastify__close-button--default {
  color: #000;
  opacity: 0.3; 
}
.Toastify__close-button:hover, .Toastify__close-button:focus {
  opacity: 1; 
}
  @keyframes Toastify__trackProgress {
    0% {
      transform: scaleX(1); }
    100% {
      transform: scaleX(0); } 
}
.Toastify__progress-bar {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 5px;
	z-index: 9999;
	opacity: 0.7;
	background-color: rgba(255, 255, 255, 0.7);
	transform-origin: left; 
}
.Toastify__progress-bar--animated {
	animation: Toastify__trackProgress linear 1 forwards; 
}
.Toastify__progress-bar--controlled {
	transition: transform .2s; 
}
.Toastify__progress-bar--rtl {
	right: 0;
	left: initial;
	transform-origin: right; 
}
.Toastify__progress-bar--default {
	background: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55); 
}
@keyframes Toastify__bounceInRight {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
    from {
      opacity: 0;
      transform: translate3d(3000px, 0, 0); }
    60% {
      opacity: 1;
      transform: translate3d(-25px, 0, 0); }
    75% {
      transform: translate3d(10px, 0, 0); }
    90% {
      transform: translate3d(-5px, 0, 0); }
    to {
      transform: none; } 
} 
@keyframes Toastify__bounceOutRight {
    20% {
      opacity: 1;
      transform: translate3d(-20px, 0, 0); }
    to {
      opacity: 0;
      transform: translate3d(2000px, 0, 0); } 
} 
@keyframes Toastify__bounceInLeft {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
    0% {
      opacity: 0;
      transform: translate3d(-3000px, 0, 0); }
    60% {
      opacity: 1;
      transform: translate3d(25px, 0, 0); }
    75% {
      transform: translate3d(-10px, 0, 0); }
    90% {
      transform: translate3d(5px, 0, 0); }
    to {
      transform: none; } 
}
@keyframes Toastify__bounceOutLeft {
    20% {
      opacity: 1;
      transform: translate3d(20px, 0, 0); }
    to {
      opacity: 0;
      transform: translate3d(-2000px, 0, 0); } 
} 
@keyframes Toastify__bounceInUp {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
    from {
      opacity: 0;
      transform: translate3d(0, 3000px, 0); }
    60% {
      opacity: 1;
      transform: translate3d(0, -20px, 0); }
    75% {
      transform: translate3d(0, 10px, 0); }
    90% {
      transform: translate3d(0, -5px, 0); }
    to {
      transform: translate3d(0, 0, 0); } 
} 
@keyframes Toastify__bounceOutUp {
    20% {
      transform: translate3d(0, -10px, 0); }
    40%,
    45% {
      opacity: 1;
      transform: translate3d(0, 20px, 0); }
    to {
      opacity: 0;
      transform: translate3d(0, -2000px, 0); } 
}
  
@keyframes Toastify__bounceInDown {
    from,
    60%,
    75%,
    90%,
    to {
      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }
    0% {
      opacity: 0;
      transform: translate3d(0, -3000px, 0); }
    60% {
      opacity: 1;
      transform: translate3d(0, 25px, 0); }
    75% {
      transform: translate3d(0, -10px, 0); }
    90% {
      transform: translate3d(0, 5px, 0); }
    to {
      transform: none; } 
} 
@keyframes Toastify__bounceOutDown {
    20% {
      transform: translate3d(0, 10px, 0); }
    40%,
    45% {
      opacity: 1;
      transform: translate3d(0, -20px, 0); }
    to {
      opacity: 0;
      transform: translate3d(0, 2000px, 0); } 
}
.Toastify__bounce-enter--top-left, .Toastify__bounce-enter--bottom-left {
	animation-name: Toastify__bounceInLeft; 
}
.Toastify__bounce-enter--top-right, .Toastify__bounce-enter--bottom-right {
	animation-name: Toastify__bounceInRight; 
}
.Toastify__bounce-enter--top-center {
	animation-name: Toastify__bounceInDown; 
}
.Toastify__bounce-enter--bottom-center {
	animation-name: Toastify__bounceInUp; 
}
.Toastify__bounce-exit--top-left, .Toastify__bounce-exit--bottom-left {
	animation-name: Toastify__bounceOutLeft; 
}
.Toastify__bounce-exit--top-right, .Toastify__bounce-exit--bottom-right {
	animation-name: Toastify__bounceOutRight; 
}
.Toastify__bounce-exit--top-center {
	animation-name: Toastify__bounceOutUp; 
}
.Toastify__bounce-exit--bottom-center {
	animation-name: Toastify__bounceOutDown; 
}
@keyframes Toastify__zoomIn {
    from {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3); }
    50% {
      opacity: 1; } 
}
@keyframes Toastify__zoomOut {
    from {
      opacity: 1; }
    50% {
      opacity: 0;
      transform: scale3d(0.3, 0.3, 0.3); }
    to {
      opacity: 0; } 
}
.Toastify__zoom-enter {
	animation-name: Toastify__zoomIn; }

.Toastify__zoom-exit {
	animation-name: Toastify__zoomOut; 
} 
@keyframes Toastify__flipIn {
    from {
      transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
      animation-timing-function: ease-in;
      opacity: 0; }
    40% {
      transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
      animation-timing-function: ease-in; }
    60% {
      transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
      opacity: 1; }
    80% {
      transform: perspective(400px) rotate3d(1, 0, 0, -5deg); }
    to {
      transform: perspective(400px); } 
} 
@keyframes Toastify__flipOut {
    from {
      transform: perspective(400px); }
    30% {
      transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
      opacity: 1; }
    to {
      transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
      opacity: 0; } 
}
  
.Toastify__flip-enter {
	animation-name: Toastify__flipIn; 
}
.Toastify__flip-exit {
	animation-name: Toastify__flipOut; 
}
  @keyframes Toastify__slideInRight {
    from {
      transform: translate3d(110%, 0, 0);
      visibility: visible; }
    to {
      transform: translate3d(0, 0, 0); } }
  
  @keyframes Toastify__slideInLeft {
    from {
      transform: translate3d(-110%, 0, 0);
      visibility: visible; }
    to {
      transform: translate3d(0, 0, 0); } }
  
  @keyframes Toastify__slideInUp {
    from {
      transform: translate3d(0, 110%, 0);
      visibility: visible; }
    to {
      transform: translate3d(0, 0, 0); } }
  
  @keyframes Toastify__slideInDown {
    from {
      transform: translate3d(0, -110%, 0);
      visibility: visible; }
    to {
      transform: translate3d(0, 0, 0); } }
  
  @keyframes Toastify__slideOutRight {
    from {
      transform: translate3d(0, 0, 0); }
    to {
      visibility: hidden;
      transform: translate3d(110%, 0, 0); } }
  
  @keyframes Toastify__slideOutLeft {
    from {
      transform: translate3d(0, 0, 0); }
    to {
      visibility: hidden;
      transform: translate3d(-110%, 0, 0); } }
  
  @keyframes Toastify__slideOutDown {
    from {
      transform: translate3d(0, 0, 0); }
    to {
      visibility: hidden;
      transform: translate3d(0, 500px, 0); } }
  
  @keyframes Toastify__slideOutUp {
    from {
      transform: translate3d(0, 0, 0); }
    to {
      visibility: hidden;
      transform: translate3d(0, -500px, 0); } 
}
.Toastify__slide-enter--top-left, .Toastify__slide-enter--bottom-left {
	animation-name: Toastify__slideInLeft; 
}
.Toastify__slide-enter--top-right, .Toastify__slide-enter--bottom-right {
	animation-name: Toastify__slideInRight; 
}
.Toastify__slide-enter--top-center {
	animation-name: Toastify__slideInDown; 
}
.Toastify__slide-enter--bottom-center {
	animation-name: Toastify__slideInUp; 
}
.Toastify__slide-exit--top-left, .Toastify__slide-exit--bottom-left {
	animation-name: Toastify__slideOutLeft; 
}
.Toastify__slide-exit--top-right, .Toastify__slide-exit--bottom-right {
	animation-name: Toastify__slideOutRight; 
}
.Toastify__slide-exit--top-center {
	animation-name: Toastify__slideOutUp; 
}
.Toastify__slide-exit--bottom-center {
	animation-name: Toastify__slideOutDown; 
}
.warning_message_box_long .message_descriptipn{
	width: 100%;
}
.warning_message_box_long .password-inner-box{
	padding: 4px 0px 0px 0px;
	margin: 0px 0px 0px 0px;
	list-style: none;
}
.warning_message_box_long .password-inner-box li{
	font-size: 13px;
}
.warning_message_box_long .error_title{
  color: #334D6E !important;
  padding: 0.5vw 0vw 0.5vw 0vw;
  text-align: center;
}
.warning_message_box_long .message_descriptipn{
  color: #8095AB !important;
}
.alertBoxInner{
  cursor: auto;
}
.titleboxInner{
  width: 100%;
  display: inline-block;
}
.titleboxLeftPanel{
  width: 50px;
  float: left;
  text-align: center;
}
.titleboxLeftPanel img{
  height: 42px;
}
.titleboxRightPanel{
  width: 230px;
  float: left;
  padding: 0px 0px 0px 10px;
}
.titleboxRightPanel .alertTitle{
  font-size: 16px;
  font-weight: 700;
  margin: 0px 0px 4px 0px;
}
.titleboxRightPanel .alertDes{
  font-size: 14px;
  margin: 0px;
  font-weight: 600;
}
.button-inner{
  text-align: left;
  padding: 10px 0px 0px 0px;
}
.button-inner .alert_cancel_btn{
  font-size: 14px;
  font-weight: 600;
  padding: 2px 10px 4px 10px;
  border: 1px solid #003F59;
  background-color: #003F59;
  color: #fff;
  line-height: 20px;
  margin-left: 6px;
  min-width: 65px;
}
.button-inner .alert_delete_btn{
  font-size: 14px;
  font-weight: 600;
  padding: 2px 10px 4px 10px;
  border: 1px solid red;
  background-color: red;
  color: #fff;
  line-height: 20px;
  margin-right: 6px;
  min-width: 65px;
}
.tostify-inner-box{
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.iconbox{
  float: left;
  width: 50px;
  display: flex;
  align-items: center;
}
.titleanddescriptionbox{
  width: 220px;
  float: left;
  word-break:break-word;
}
.titleanddescriptionbox h1 {
  padding: 0.5vw 0vw 0vw 0.5vw;
}
.titleanddescriptionbox .message_dec{
  width: 100%;
}
.iconbox .alert_img{
  top: 0;
}
.iconbox .alert_img_warning{
  top: 0;
}
.Toastify__toast-icon{
  display: none;
}

.errorToastMsg{
  flex-direction: row-reverse;
  justify-content: space-around;
  .alert_box .message_dec{
    padding: 0px 0px 0px 0.5vw;
  }

} `, "",{"version":3,"sources":["webpack://./src/Utility/Public/css/toastify.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,kDAAkD;IAClD,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,sBAAsB;IACtB,WAAW;IACX,qBAAqB;AACzB;AACA;EACE,QAAQ;EACR,QAAQ;EACR,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,QAAQ;EACR,OAAO;EACP,gBAAgB;AAClB;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,WAAW;EACX,SAAS;AACX;AACA;EACE,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;IACX,UAAU;IACV,SAAS;IACT,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,MAAM;EACR;EACA;IACE,0BAA0B;IAC1B,QAAQ;EACV;EACA;IACE,QAAQ;IACR,aAAa;EACf;EACA;MACI,qBAAqB;EACzB;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,sBAAsB;CACtB,mBAAmB;CACnB,YAAY;CACZ,kBAAkB;CAClB,6EAA6E;CAC7E,oBAAoB;CACpB,aAAa;CACb,sBAAsB;CACtB,8BAA8B;CAC9B,iBAAiB;CACjB,gBAAgB;CAChB,8JAA8J;CAC9J,eAAe;CACf,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,gBAAgB;CAChB,WAAW;AACZ;AACA;CACC,mBAAmB;AACpB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,WAAW;CACX,WAAW;CACX,oEAAqE;CACrE,4BAA4B;CAC5B,+BAA+B;CAC/B,iCAAiC;EAChC,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;AACA;CACC,WAAW;CACX,WAAW;CACX,oEAAmE;CACnE,4BAA4B;CAC5B,iCAAiC;EAChC,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AACA;CACC,WAAW;CACX,WAAW;CACX,oEAAuE;CACvE,4BAA4B;CAC5B,iCAAiC;EAChC,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;AACzB;AACA;CACC,WAAW;CACX,WAAW;CACX,oEAA+D;CAC/D,4BAA4B;CAC5B,iCAAiC;CACjC,qBAAqB;EACpB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,kCAAkC;EAClC,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,WAAW;CACZ,WAAW;CACX,oEAA+D;CAC/D,4BAA4B;CAC5B,iCAAiC;EAChC,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;CACZ,WAAW;AACZ;AACA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;CACzB,gBAAgB;AACjB;AACA;CACC,qBAAqB;CACrB,UAAU;CACV,eAAe;CACf,cAAc;EACb,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,qBAAqB;CACtB,UAAU;CACV,eAAe;CACf,sBAAsB;AACvB;AACA;EACE,8BAA8B;EAC9B,4CAA4C;EAC5C,kBAAkB;EAClB,SAAS;CACV,UAAU;CACV,gBAAgB;AACjB;AACA;CACC,4BAA4B;CAC5B,kBAAkB;CAClB,yBAAyB;CACzB,YAAY;CACZ,oEAA+D;CAC/D,uCAAuC;CACvC,2CAA2C;CAC3C,oCAAoC;AACrC;AACA;EACE,8BAA8B;CAC/B,kBAAkB;CAClB,4CAA4C;CAC5C,UAAU;CACV;;8CAE6C;CAC7C,iCAAiC;AAClC;AACA;EACE,8BAA8B;CAC/B,kBAAkB;CAClB,4CAA4C;CAC5C,UAAU;CACV;;8CAE6C;CAC7C,iCAAiC;AAClC;AACA;EACE,4CAA4C;CAC7C,UAAU;AACX;AACA;EACE,4CAA4C;CAC7C,UAAU;AACX;AACA;EACE,4CAA4C;CAC7C,UAAU;AACX;AACA;EACE,4CAA4C;CAC7C,UAAU;AACX;AACA;CACC,uBAAuB;CACvB,eAAe;CACf,gBAAgB;CAChB,cAAc;EACb,4BAA4B;EAC5B,2BAA2B;AAC7B;AACA;CACC,eAAe;CACf,WAAW;AACZ;AACA;CACC,UAAU;AACX;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,OAAO;AACT;AACA;IACI,eAAe;GAChB,WAAW;AACd;AACA;CACC,WAAW;CACX,eAAe;AAChB;AACA;CACC,WAAW;CACX,eAAe;AAChB;AACA;EACE,sBAAsB;CACvB,eAAe;AAChB;AACA;EACE,sBAAsB;CACvB,eAAe;AAChB;AACA;EACE,eAAe;AACjB;AACA;CACC;GACE,gBAAgB,EAAE;AACrB;;AAEA;CACC,WAAW;CACX,iBAAiB;CACjB,uBAAuB;CACvB,aAAa;CACb,YAAY;CACZ,UAAU;CACV,eAAe;CACf,UAAU;CACV,qBAAqB;CACrB,0BAA0B;CAC1B,sBAAsB;CACtB,kBAAkB;CAClB,SAAS;CACT,WAAW;CACX,gBAAgB;CAChB,eAAe;CACf,yBAAyB;EACxB,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,UAAU;AACZ;EACE;IACE;MACE,oBAAoB,EAAE;IACxB;MACE,oBAAoB,EAAE;AAC5B;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,WAAW;CACX,WAAW;CACX,aAAa;CACb,YAAY;CACZ,0CAA0C;CAC1C,sBAAsB;AACvB;AACA;CACC,oDAAoD;AACrD;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,QAAQ;CACR,aAAa;CACb,uBAAuB;AACxB;AACA;CACC,2FAA2F;AAC5F;AACA;IACI;;;;;MAKE,8DAA8D,EAAE;IAClE;MACE,UAAU;MACV,oCAAoC,EAAE;IACxC;MACE,UAAU;MACV,mCAAmC,EAAE;IACvC;MACE,kCAAkC,EAAE;IACtC;MACE,kCAAkC,EAAE;IACtC;MACE,eAAe,EAAE;AACvB;AACA;IACI;MACE,UAAU;MACV,mCAAmC,EAAE;IACvC;MACE,UAAU;MACV,oCAAoC,EAAE;AAC5C;AACA;IACI;;;;;MAKE,8DAA8D,EAAE;IAClE;MACE,UAAU;MACV,qCAAqC,EAAE;IACzC;MACE,UAAU;MACV,kCAAkC,EAAE;IACtC;MACE,mCAAmC,EAAE;IACvC;MACE,iCAAiC,EAAE;IACrC;MACE,eAAe,EAAE;AACvB;AACA;IACI;MACE,UAAU;MACV,kCAAkC,EAAE;IACtC;MACE,UAAU;MACV,qCAAqC,EAAE;AAC7C;AACA;IACI;;;;;MAKE,8DAA8D,EAAE;IAClE;MACE,UAAU;MACV,oCAAoC,EAAE;IACxC;MACE,UAAU;MACV,mCAAmC,EAAE;IACvC;MACE,kCAAkC,EAAE;IACtC;MACE,kCAAkC,EAAE;IACtC;MACE,+BAA+B,EAAE;AACvC;AACA;IACI;MACE,mCAAmC,EAAE;IACvC;;MAEE,UAAU;MACV,kCAAkC,EAAE;IACtC;MACE,UAAU;MACV,qCAAqC,EAAE;AAC7C;;AAEA;IACI;;;;;MAKE,8DAA8D,EAAE;IAClE;MACE,UAAU;MACV,qCAAqC,EAAE;IACzC;MACE,UAAU;MACV,kCAAkC,EAAE;IACtC;MACE,mCAAmC,EAAE;IACvC;MACE,iCAAiC,EAAE;IACrC;MACE,eAAe,EAAE;AACvB;AACA;IACI;MACE,kCAAkC,EAAE;IACtC;;MAEE,UAAU;MACV,mCAAmC,EAAE;IACvC;MACE,UAAU;MACV,oCAAoC,EAAE;AAC5C;AACA;CACC,sCAAsC;AACvC;AACA;CACC,uCAAuC;AACxC;AACA;CACC,sCAAsC;AACvC;AACA;CACC,oCAAoC;AACrC;AACA;CACC,uCAAuC;AACxC;AACA;CACC,wCAAwC;AACzC;AACA;CACC,qCAAqC;AACtC;AACA;CACC,uCAAuC;AACxC;AACA;IACI;MACE,UAAU;MACV,iCAAiC,EAAE;IACrC;MACE,UAAU,EAAE;AAClB;AACA;IACI;MACE,UAAU,EAAE;IACd;MACE,UAAU;MACV,iCAAiC,EAAE;IACrC;MACE,UAAU,EAAE;AAClB;AACA;CACC,gCAAgC,EAAE;;AAEnC;CACC,iCAAiC;AAClC;AACA;IACI;MACE,sDAAsD;MACtD,kCAAkC;MAClC,UAAU,EAAE;IACd;MACE,uDAAuD;MACvD,kCAAkC,EAAE;IACtC;MACE,sDAAsD;MACtD,UAAU,EAAE;IACd;MACE,sDAAsD,EAAE;IAC1D;MACE,6BAA6B,EAAE;AACrC;AACA;IACI;MACE,6BAA6B,EAAE;IACjC;MACE,uDAAuD;MACvD,UAAU,EAAE;IACd;MACE,sDAAsD;MACtD,UAAU,EAAE;AAClB;;AAEA;CACC,gCAAgC;AACjC;AACA;CACC,iCAAiC;AAClC;EACE;IACE;MACE,kCAAkC;MAClC,mBAAmB,EAAE;IACvB;MACE,+BAA+B,EAAE,EAAE;;EAEvC;IACE;MACE,mCAAmC;MACnC,mBAAmB,EAAE;IACvB;MACE,+BAA+B,EAAE,EAAE;;EAEvC;IACE;MACE,kCAAkC;MAClC,mBAAmB,EAAE;IACvB;MACE,+BAA+B,EAAE,EAAE;;EAEvC;IACE;MACE,mCAAmC;MACnC,mBAAmB,EAAE;IACvB;MACE,+BAA+B,EAAE,EAAE;;EAEvC;IACE;MACE,+BAA+B,EAAE;IACnC;MACE,kBAAkB;MAClB,kCAAkC,EAAE,EAAE;;EAE1C;IACE;MACE,+BAA+B,EAAE;IACnC;MACE,kBAAkB;MAClB,mCAAmC,EAAE,EAAE;;EAE3C;IACE;MACE,+BAA+B,EAAE;IACnC;MACE,kBAAkB;MAClB,mCAAmC,EAAE,EAAE;;EAE3C;IACE;MACE,+BAA+B,EAAE;IACnC;MACE,kBAAkB;MAClB,oCAAoC,EAAE;AAC5C;AACA;CACC,qCAAqC;AACtC;AACA;CACC,sCAAsC;AACvC;AACA;CACC,qCAAqC;AACtC;AACA;CACC,mCAAmC;AACpC;AACA;CACC,sCAAsC;AACvC;AACA;CACC,uCAAuC;AACxC;AACA;CACC,oCAAoC;AACrC;AACA;CACC,sCAAsC;AACvC;AACA;CACC,WAAW;AACZ;AACA;CACC,wBAAwB;CACxB,uBAAuB;CACvB,gBAAgB;AACjB;AACA;CACC,eAAe;AAChB;AACA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,qBAAqB;EACrB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;EACX,aAAa;EACb,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,WAAW;AACb;AACA;EACE,MAAM;AACR;AACA;EACE,MAAM;AACR;AACA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B;IACE,0BAA0B;EAC5B;;AAEF","sourcesContent":[".Toastify__toast-container {\n    z-index: 99999;\n    /* -webkit-transform: translate3d(0, 0, 9999px); */\n    position: fixed;\n    padding: 4px;\n    width: 307px;\n    box-sizing: border-box;\n    color: #fff; \n    word-break: break-all;\n}\n.Toastify__toast-container--top-left {\n  top: 45%;\n  right: 0;\n  left: 0;\n  margin: 0px auto;\n}\n.Toastify__toast-container--top-center {\n  top: 8px;\n  right: 0;\n  left: 0;\n  margin: 0px auto;\n}\n.Toastify__toast-container--top-right {\n  top: 7em;\n  right: 1em; \n}\n.Toastify__toast-container--bottom-left {\n  bottom: 1em;\n  left: 1em; \n}\n.Toastify__toast-container--bottom-center {\n  bottom: 1em;\n  left: 50%;\n  margin-left: -160px; \n}\n.Toastify__toast-container--bottom-right {\n  bottom: 1em;\n  right: 1em; \n}\n  \n@media only screen and (max-width: 480px) {\n  .Toastify__toast-container {\n    width: 95vw;\n    padding: 0;\n    left: 6px;\n    right: 6px;\n    margin: 0px auto; \n  }\n  .Toastify__toast-container--top-left, .Toastify__toast-container--top-center, .Toastify__toast-container--top-right {\n    top: 0; \n  }\n  .Toastify__toast-container--bottom-left, .Toastify__toast-container--bottom-center, .Toastify__toast-container--bottom-right {\n    bottom: inherit !important; \n    top:10px;\n  }\n  .Toastify__toast-container--rtl {\n    right: 0;\n    left: initial; \n  } \n  .titleanddescriptionbox{\n      width: 80% !important;\n  }\n  .message_dec p{\n    font-size: 13px !important;\n  }\n  .titleanddescriptionbox .alert_box {\n    padding-top: 6px;\n  }\n}\n  \n.Toastify__toast {\n\tposition: relative;\n\tmin-height: 64px;\n\tbox-sizing: border-box;\n\tmargin-bottom: 1rem;\n\tpadding: 8px;\n\tborder-radius: 1px;\n\tbox-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1), 0 2px 15px 0 rgba(0, 0, 0, 0.05);\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-ms-flex-pack: justify;\n\tjustify-content: space-between;\n\tmax-height: 800px;\n\toverflow: hidden;\n\tfont-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n\tcursor: pointer;\n\tdirection: ltr; \n}\n.Toastify__toast--rtl {\n\tdirection: rtl; \n}\n.Toastify__toast--default {\n\tbackground: #fff;\n\tcolor: #aaa; \n}\n.Toastify__toast--info {\n\tbackground: #3498db; \n}\n.alert_box{\n\tpadding: 10px 0px 0px 0px;\n}\n.alert_img{\n\twidth: 50px;\n\tfloat: left;\n\tbackground-image: url(\"../images/toastify/successimg.png\") !important;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 8px center;\n\tbackground-color: #fff !important;\n  background-size: 50px;\n  height: 50px;\n  position: relative;\n  top: -14px;\n  border-radius: 50%;\n}\n.alert_img_error{\n\twidth: 50px;\n\tfloat: left;\n\tbackground-image: url(\"../images/toastify/errorimg.png\") !important;\n\tbackground-repeat: no-repeat;\n\tbackground-color: #fff !important;\n  background-size: 50px;\n  height: 50px;\n  position: relative;\n  border-radius: 50%;\n}\n.alert_img_warning{\n\twidth: 50px;\n\tfloat: left;\n\tbackground-image: url(\"../images/toastify/warnningIcon.png\") !important;\n\tbackground-repeat: no-repeat;\n\tbackground-color: #fff !important;\n  background-size: 50px;\n  height: 50px;\n  position: relative;\n  border-radius: 50%;\n}\n.alert_box_reminder .alert_box{\n  display: flex;\n  width: 100%;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 0px !important;\n}\n.alert_img_reminder{\n\twidth: 45px;\n\tfloat: left;\n\tbackground-image: url(\"../images/toastify/bell.png\") !important;\n\tbackground-repeat: no-repeat;\n\tbackground-color: #fff !important;\n\tbackground-size: 50px;\n  height: 45px;\n  position: relative;\n  border-radius: 50%;\n  background-size: 60%;\n  background-position: center center;\n  box-shadow: 0px 0px 5px 2px #eee;\n}\n.infoToastMsg{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.alert_img_info{\n  width: 50px;\n\tfloat: left;\n\tbackground-image: url(\"../images/toastify/info.png\") !important;\n\tbackground-repeat: no-repeat;\n\tbackground-color: #fff !important;\n  background-size: 50px;\n  height: 50px;\n  position: relative;\n  border-radius: 50%;\n}\n.infoToastMsg .iconbox{\n  width: 50px;\n\tfloat: left;\n}\n.infoToastMsg .alert_img_info img{\n\twidth: 50px;\n\theight: 50px;\n\tborder-radius: 50%;\n\tborder: 1px solid #DFE0EB;\n\tpadding: 2px 2px;\n}\n.message_dec{\n\tdisplay: inline-block;\n\twidth: 80%;\n\tfont-size: 12px;\n\tcolor: #8095AB;\n  font-family: Poppins-Medium;\n  padding: 0px 0px 0px 0.8vw;\n}\n.message_descriptipn{\n  display: inline-block;\n\twidth: 80%;\n\tfont-size: 12px;\n\tcolor: #fff !important;\n}\n.Toastify__toast--success {\n  padding: 0.8vw 0.7vw 1vw 0.6vw;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);\n  border-radius: 1vw;\n  margin: 0;\n\topacity: 1;\n\tbackground: #fff;\n}\n.Toastify__toast--info{\n\tpadding: 15px 15px 15px 50px;\n\tborder-radius: 3px;\n\tbox-shadow: 0 0 12px #999;\n\topacity: 0.8;\n\tbackground-image: url(\"../images/toastify/info.png\") !important;\n\tbackground-repeat: no-repeat !important;\n\tbackground-position: 15px center !important;\n\tbackground-color: #2F96B4 !important;\n}\n.Toastify__toast--warning{\n  padding: 0.8vw 0.7vw 1vw 0.6vw;\n\tborder-radius: 1vw;\n\tbox-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);\n\topacity: 1;\n\t/*background-image: url(\"../images/toastify/warning.png\") !important;\n\tbackground-repeat: no-repeat !important;\n\tbackground-position: 15px center !important;*/\n\tbackground-color: #fff !important;\n}\n.Toastify__toast--error{\n  padding: 0.8vw 0.7vw 1vw 0.6vw;\n\tborder-radius: 1vw;\n\tbox-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);\n\topacity: 1;\n\t/*background-image: url(\"../images/toastify/error.png\") !important;\n\tbackground-repeat: no-repeat !important;\n\tbackground-position: 15px center !important;*/\n\tbackground-color: #fff !important;\n}\n.Toastify__toast--success:hover{\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);\n\topacity: 1;\n}\n.Toastify__toast--info:hover{\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);\n\topacity: 1;\n}\n.Toastify__toast--warning:hover{\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);\n\topacity: 1;\n}\n.Toastify__toast--error:hover{\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);\n\topacity: 1;\n}\n.Toastify__toast-body h1{\n\tmargin: 0px 0px 0px 0px;\n\tfont-size: 16px;\n\tfont-weight: 700;\n\tcolor: #334D6E;\n  padding: 0.5vw 0vw 0vw 3.5vw;\n  font-family: Poppins-Medium;\n}\n.Toastify__toast-body{\n\ttext-align:left;\n\tcolor: #555;\n}\n.Toastify__toast--success:hover{\n\topacity: 1;\n}\n.Toastify__toast--warning {\n  background: #f1c40f; \n}\n.Toastify__toast--error {\n  background: #e74c3c; \n}\n.Toastify__toast-body {\n  margin: auto 0;\n  -ms-flex: 1;\n  flex: 1; \n}\n.Toastify__toast-body .info_title_text {\n    font-size: 15px;\n\t  color: #000;\n}\n.warning_message_box h1{\n\tcolor: #fff;\n\tfont-size: 16px;\n}\n.warning_message_box{\n\tcolor: #fff;\n\tfont-size: 15px;\n}\n.error_title{\n  color: #fff !important;\n\tfont-size: 15px;\n}\n.warning_title{\n  color: #fff !important;\n\tfont-size: 15px;\n}\n.error_title_dec{\n  font-size: 14px;\n}\n@media only screen and (max-width: 480px) {\n\t.Toastify__toast {\n\t  margin-bottom: 0; } \n}\n\n.Toastify__close-button {\n\tcolor: #555;\n\tfont-weight: bold;\n\tbackground: transparent;\n\toutline: none;\n\tborder: none;\n\tpadding: 0;\n\tcursor: pointer;\n\topacity: 1;\n\ttransition: 0.3s ease;\n\t-ms-flex-item-align: start;\n\talign-self: flex-start; \n\tposition: relative;\n\ttop: -6px;\n\tright: -0px;\n\tfont-weight: 900;\n\tfont-size: 16px;\n\ttext-shadow: 0 1px 0 #fff;\n  display: none;\n}\n.Toastify__close-button--default {\n  color: #000;\n  opacity: 0.3; \n}\n.Toastify__close-button:hover, .Toastify__close-button:focus {\n  opacity: 1; \n}\n  @keyframes Toastify__trackProgress {\n    0% {\n      transform: scaleX(1); }\n    100% {\n      transform: scaleX(0); } \n}\n.Toastify__progress-bar {\n\tposition: absolute;\n\tbottom: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 5px;\n\tz-index: 9999;\n\topacity: 0.7;\n\tbackground-color: rgba(255, 255, 255, 0.7);\n\ttransform-origin: left; \n}\n.Toastify__progress-bar--animated {\n\tanimation: Toastify__trackProgress linear 1 forwards; \n}\n.Toastify__progress-bar--controlled {\n\ttransition: transform .2s; \n}\n.Toastify__progress-bar--rtl {\n\tright: 0;\n\tleft: initial;\n\ttransform-origin: right; \n}\n.Toastify__progress-bar--default {\n\tbackground: linear-gradient(to right, #4cd964, #5ac8fa, #007aff, #34aadc, #5856d6, #ff2d55); \n}\n@keyframes Toastify__bounceInRight {\n    from,\n    60%,\n    75%,\n    90%,\n    to {\n      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }\n    from {\n      opacity: 0;\n      transform: translate3d(3000px, 0, 0); }\n    60% {\n      opacity: 1;\n      transform: translate3d(-25px, 0, 0); }\n    75% {\n      transform: translate3d(10px, 0, 0); }\n    90% {\n      transform: translate3d(-5px, 0, 0); }\n    to {\n      transform: none; } \n} \n@keyframes Toastify__bounceOutRight {\n    20% {\n      opacity: 1;\n      transform: translate3d(-20px, 0, 0); }\n    to {\n      opacity: 0;\n      transform: translate3d(2000px, 0, 0); } \n} \n@keyframes Toastify__bounceInLeft {\n    from,\n    60%,\n    75%,\n    90%,\n    to {\n      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }\n    0% {\n      opacity: 0;\n      transform: translate3d(-3000px, 0, 0); }\n    60% {\n      opacity: 1;\n      transform: translate3d(25px, 0, 0); }\n    75% {\n      transform: translate3d(-10px, 0, 0); }\n    90% {\n      transform: translate3d(5px, 0, 0); }\n    to {\n      transform: none; } \n}\n@keyframes Toastify__bounceOutLeft {\n    20% {\n      opacity: 1;\n      transform: translate3d(20px, 0, 0); }\n    to {\n      opacity: 0;\n      transform: translate3d(-2000px, 0, 0); } \n} \n@keyframes Toastify__bounceInUp {\n    from,\n    60%,\n    75%,\n    90%,\n    to {\n      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }\n    from {\n      opacity: 0;\n      transform: translate3d(0, 3000px, 0); }\n    60% {\n      opacity: 1;\n      transform: translate3d(0, -20px, 0); }\n    75% {\n      transform: translate3d(0, 10px, 0); }\n    90% {\n      transform: translate3d(0, -5px, 0); }\n    to {\n      transform: translate3d(0, 0, 0); } \n} \n@keyframes Toastify__bounceOutUp {\n    20% {\n      transform: translate3d(0, -10px, 0); }\n    40%,\n    45% {\n      opacity: 1;\n      transform: translate3d(0, 20px, 0); }\n    to {\n      opacity: 0;\n      transform: translate3d(0, -2000px, 0); } \n}\n  \n@keyframes Toastify__bounceInDown {\n    from,\n    60%,\n    75%,\n    90%,\n    to {\n      animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1); }\n    0% {\n      opacity: 0;\n      transform: translate3d(0, -3000px, 0); }\n    60% {\n      opacity: 1;\n      transform: translate3d(0, 25px, 0); }\n    75% {\n      transform: translate3d(0, -10px, 0); }\n    90% {\n      transform: translate3d(0, 5px, 0); }\n    to {\n      transform: none; } \n} \n@keyframes Toastify__bounceOutDown {\n    20% {\n      transform: translate3d(0, 10px, 0); }\n    40%,\n    45% {\n      opacity: 1;\n      transform: translate3d(0, -20px, 0); }\n    to {\n      opacity: 0;\n      transform: translate3d(0, 2000px, 0); } \n}\n.Toastify__bounce-enter--top-left, .Toastify__bounce-enter--bottom-left {\n\tanimation-name: Toastify__bounceInLeft; \n}\n.Toastify__bounce-enter--top-right, .Toastify__bounce-enter--bottom-right {\n\tanimation-name: Toastify__bounceInRight; \n}\n.Toastify__bounce-enter--top-center {\n\tanimation-name: Toastify__bounceInDown; \n}\n.Toastify__bounce-enter--bottom-center {\n\tanimation-name: Toastify__bounceInUp; \n}\n.Toastify__bounce-exit--top-left, .Toastify__bounce-exit--bottom-left {\n\tanimation-name: Toastify__bounceOutLeft; \n}\n.Toastify__bounce-exit--top-right, .Toastify__bounce-exit--bottom-right {\n\tanimation-name: Toastify__bounceOutRight; \n}\n.Toastify__bounce-exit--top-center {\n\tanimation-name: Toastify__bounceOutUp; \n}\n.Toastify__bounce-exit--bottom-center {\n\tanimation-name: Toastify__bounceOutDown; \n}\n@keyframes Toastify__zoomIn {\n    from {\n      opacity: 0;\n      transform: scale3d(0.3, 0.3, 0.3); }\n    50% {\n      opacity: 1; } \n}\n@keyframes Toastify__zoomOut {\n    from {\n      opacity: 1; }\n    50% {\n      opacity: 0;\n      transform: scale3d(0.3, 0.3, 0.3); }\n    to {\n      opacity: 0; } \n}\n.Toastify__zoom-enter {\n\tanimation-name: Toastify__zoomIn; }\n\n.Toastify__zoom-exit {\n\tanimation-name: Toastify__zoomOut; \n} \n@keyframes Toastify__flipIn {\n    from {\n      transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n      animation-timing-function: ease-in;\n      opacity: 0; }\n    40% {\n      transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n      animation-timing-function: ease-in; }\n    60% {\n      transform: perspective(400px) rotate3d(1, 0, 0, 10deg);\n      opacity: 1; }\n    80% {\n      transform: perspective(400px) rotate3d(1, 0, 0, -5deg); }\n    to {\n      transform: perspective(400px); } \n} \n@keyframes Toastify__flipOut {\n    from {\n      transform: perspective(400px); }\n    30% {\n      transform: perspective(400px) rotate3d(1, 0, 0, -20deg);\n      opacity: 1; }\n    to {\n      transform: perspective(400px) rotate3d(1, 0, 0, 90deg);\n      opacity: 0; } \n}\n  \n.Toastify__flip-enter {\n\tanimation-name: Toastify__flipIn; \n}\n.Toastify__flip-exit {\n\tanimation-name: Toastify__flipOut; \n}\n  @keyframes Toastify__slideInRight {\n    from {\n      transform: translate3d(110%, 0, 0);\n      visibility: visible; }\n    to {\n      transform: translate3d(0, 0, 0); } }\n  \n  @keyframes Toastify__slideInLeft {\n    from {\n      transform: translate3d(-110%, 0, 0);\n      visibility: visible; }\n    to {\n      transform: translate3d(0, 0, 0); } }\n  \n  @keyframes Toastify__slideInUp {\n    from {\n      transform: translate3d(0, 110%, 0);\n      visibility: visible; }\n    to {\n      transform: translate3d(0, 0, 0); } }\n  \n  @keyframes Toastify__slideInDown {\n    from {\n      transform: translate3d(0, -110%, 0);\n      visibility: visible; }\n    to {\n      transform: translate3d(0, 0, 0); } }\n  \n  @keyframes Toastify__slideOutRight {\n    from {\n      transform: translate3d(0, 0, 0); }\n    to {\n      visibility: hidden;\n      transform: translate3d(110%, 0, 0); } }\n  \n  @keyframes Toastify__slideOutLeft {\n    from {\n      transform: translate3d(0, 0, 0); }\n    to {\n      visibility: hidden;\n      transform: translate3d(-110%, 0, 0); } }\n  \n  @keyframes Toastify__slideOutDown {\n    from {\n      transform: translate3d(0, 0, 0); }\n    to {\n      visibility: hidden;\n      transform: translate3d(0, 500px, 0); } }\n  \n  @keyframes Toastify__slideOutUp {\n    from {\n      transform: translate3d(0, 0, 0); }\n    to {\n      visibility: hidden;\n      transform: translate3d(0, -500px, 0); } \n}\n.Toastify__slide-enter--top-left, .Toastify__slide-enter--bottom-left {\n\tanimation-name: Toastify__slideInLeft; \n}\n.Toastify__slide-enter--top-right, .Toastify__slide-enter--bottom-right {\n\tanimation-name: Toastify__slideInRight; \n}\n.Toastify__slide-enter--top-center {\n\tanimation-name: Toastify__slideInDown; \n}\n.Toastify__slide-enter--bottom-center {\n\tanimation-name: Toastify__slideInUp; \n}\n.Toastify__slide-exit--top-left, .Toastify__slide-exit--bottom-left {\n\tanimation-name: Toastify__slideOutLeft; \n}\n.Toastify__slide-exit--top-right, .Toastify__slide-exit--bottom-right {\n\tanimation-name: Toastify__slideOutRight; \n}\n.Toastify__slide-exit--top-center {\n\tanimation-name: Toastify__slideOutUp; \n}\n.Toastify__slide-exit--bottom-center {\n\tanimation-name: Toastify__slideOutDown; \n}\n.warning_message_box_long .message_descriptipn{\n\twidth: 100%;\n}\n.warning_message_box_long .password-inner-box{\n\tpadding: 4px 0px 0px 0px;\n\tmargin: 0px 0px 0px 0px;\n\tlist-style: none;\n}\n.warning_message_box_long .password-inner-box li{\n\tfont-size: 13px;\n}\n.warning_message_box_long .error_title{\n  color: #334D6E !important;\n  padding: 0.5vw 0vw 0.5vw 0vw;\n  text-align: center;\n}\n.warning_message_box_long .message_descriptipn{\n  color: #8095AB !important;\n}\n.alertBoxInner{\n  cursor: auto;\n}\n.titleboxInner{\n  width: 100%;\n  display: inline-block;\n}\n.titleboxLeftPanel{\n  width: 50px;\n  float: left;\n  text-align: center;\n}\n.titleboxLeftPanel img{\n  height: 42px;\n}\n.titleboxRightPanel{\n  width: 230px;\n  float: left;\n  padding: 0px 0px 0px 10px;\n}\n.titleboxRightPanel .alertTitle{\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0px 0px 4px 0px;\n}\n.titleboxRightPanel .alertDes{\n  font-size: 14px;\n  margin: 0px;\n  font-weight: 600;\n}\n.button-inner{\n  text-align: left;\n  padding: 10px 0px 0px 0px;\n}\n.button-inner .alert_cancel_btn{\n  font-size: 14px;\n  font-weight: 600;\n  padding: 2px 10px 4px 10px;\n  border: 1px solid #003F59;\n  background-color: #003F59;\n  color: #fff;\n  line-height: 20px;\n  margin-left: 6px;\n  min-width: 65px;\n}\n.button-inner .alert_delete_btn{\n  font-size: 14px;\n  font-weight: 600;\n  padding: 2px 10px 4px 10px;\n  border: 1px solid red;\n  background-color: red;\n  color: #fff;\n  line-height: 20px;\n  margin-right: 6px;\n  min-width: 65px;\n}\n.tostify-inner-box{\n  width: 100%;\n  display: flex;\n  justify-content: space-around;\n}\n.iconbox{\n  float: left;\n  width: 50px;\n  display: flex;\n  align-items: center;\n}\n.titleanddescriptionbox{\n  width: 220px;\n  float: left;\n  word-break:break-word;\n}\n.titleanddescriptionbox h1 {\n  padding: 0.5vw 0vw 0vw 0.5vw;\n}\n.titleanddescriptionbox .message_dec{\n  width: 100%;\n}\n.iconbox .alert_img{\n  top: 0;\n}\n.iconbox .alert_img_warning{\n  top: 0;\n}\n.Toastify__toast-icon{\n  display: none;\n}\n\n.errorToastMsg{\n  flex-direction: row-reverse;\n  justify-content: space-around;\n  .alert_box .message_dec{\n    padding: 0px 0px 0px 0.5vw;\n  }\n\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
